module.exports = __webpack_public_path__ + "img/quard11.aae658a9.png";